import { ISelectorOptions } from 'components/common'
import { ActivityType } from 'generated/graphql'

export const ActivityTypeValues: ISelectorOptions = [
  { value: ActivityType.Note, label: 'Note' },
  { value: ActivityType.Meeting, label: 'Meeting' },
  { value: ActivityType.Call, label: 'Call' },
  { value: ActivityType.QuoteStatus, label: 'Quote Status' },
]
